/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ModuleFormComponent as ɵc} from './module-form/module-form.component';
export {ModuleComponent as ɵb} from './module.component';
export {declaration as ɵa} from './module.module';
export {ModuleRoutes as ɵd} from './module.routing';